import React from "react";
import { FaBullseye, FaLightbulb, FaUsers } from "react-icons/fa";
import "./About.css";

export default function About() {
  const values = [
    { icon: <FaBullseye />, title: "Our Mission", desc: "To empower businesses and individuals by delivering innovative, reliable, and tailor-made IT solutions that transform ideas into reality." },
    { icon: <FaLightbulb />, title: "Our Vision", desc: "To be a leading IT solutions partner recognized for turning visionary ideas into impactful, real-world technology experiences." },
    { icon: <FaUsers />, title: "Our Values", desc: "Innovation, integrity, teamwork, adaptability, excellence and customer-centric solutions drive everything we do." },
  ];

  return (
    <div className="about-page">
      {/* Header */}
      <section className="about-hero">
        <h1>About Us</h1>
        <p>

  At <strong>WEMINDSOLUTIONS Private Limited</strong>, we turn ideas into impactful digital experiences. Founded with a passion for technology and innovation, we help businesses and individuals build smart, scalable, and future-ready solutions.
</p>
 
<p>

  Our team of skilled professionals combines creativity, technical expertise, and strategic thinking to transform your visions into tangible, high-impact solutions. From software development and digital transformation to cutting-edge IT services, we are committed to making your dreams take shape.
  </p>
 
<p>

  Whether it’s software development, digital transformation, or innovative IT services, we move fast, adapt quickly, and stay focused on what matters most — our clients’ success.
</p>
 
<p>
<strong>Your vision. Our technology. Built for what’s next.</strong>
</p>

 
      </section>

      {/* Mission, Vision, Values */}
      <section className="about-values">
        <div className="values-container">
          {values.map((value, i) => (
            <div key={i} className="value-card">
              <div className="value-icon">{value.icon}</div>
              <h3>{value.title}</h3>
              <p>{value.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <h2>Want to work with us?</h2>
        <a href="./contact" className="contact-btn">Get in Touch</a>
      </section>
    </div>
  );
}
